import { Breadcrumb, Tabs } from 'antd'
import BreadcrumbItem from 'antd/lib/breadcrumb/BreadcrumbItem'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { Outlet, useNavigate } from 'react-router'
import { PageHeader } from '../../../Components/Header'
import Page from '../../../Layouts/AuthBaseLayout/Components/Page'
import { useHTMLTitle } from '../../../Utils/useHTMLTitle'
import NavigationBreadCrumb from 'Pages/Routes/NavigationBreadCrumb'

const { TabPane } = Tabs

const SettingsPageLayout: React.FC<any> = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setactiveTab] = useState('tags')

  useHTMLTitle('Engage Settings')

  useEffect(() => {
    const tab = location.pathname.split('settings/')[1]
    if (tab) {
      setactiveTab(tab)
      navigate(`../settings/${tab}`)
    }

    return () => {}
  }, [location?.pathname])

  return (
    <Page
      contentProps={{
        style: {
          overflow: 'auto',
        },
      }}
      header={
        <PageHeader
          title="Skit Engage"
          breadcrumb={
            <NavigationBreadCrumb
              itemList={[
                <BreadcrumbItem key={1} href={'/engage/demos'}>
                  Engage
                </BreadcrumbItem>,
                <BreadcrumbItem key={2}>Settings</BreadcrumbItem>,
              ]}
            />
          }
          footer={
            <Tabs
              activeKey={activeTab}
              size="small"
              onTabClick={(activeKey) => {
                setactiveTab(activeKey)
                navigate(`../settings/${activeKey}`)
              }}
            >
              <TabPane key="tags" tab="Manage Tags" />
              <TabPane key="audio-demos" tab="Manage Demos" />
              <TabPane key="interactive-demos" tab="Manage Interactive Demos" />
            </Tabs>
          }
        />
      }
    >
      {children}
      <Outlet />
    </Page>
  )
}

export default SettingsPageLayout
